import cn from 'clsx'
import { Link } from '~/components/link'

import ArrowSVG from '~/public/svg/arrow.svg'
import PlusSVG from '~/public/svg/plus.svg'
import TickSVG from '~/public/svg/tick.svg'

export function PricingCard({ plan, isYearly, className }) {
  const pricing = isYearly ? plan.yearly : plan.monthly

  return (
    <div
      key={plan._uid}
      className={cn(
        'relative w-full flex flex-col dr-gap-16 text-black dr-p-21 dr-pb-80 dt:dr-pb-104 bg-white dr-rounded-10',
        className
      )}
    >
      <h3 className="h5">{plan.name}</h3>
      <div className="dr-h-68">
        <p className="h3">{pricing.price}</p>
        {pricing.note && (
          <p className="cta-md-l dr-mt-6 text-light-grey">{pricing.note}</p>
        )}
      </div>

      <ul
        className={cn(
          'flex flex-col dr-gap-8 transition-transform duration-300',
          pricing.note ? '' : '-translate-y-[desktop-vw(20px)]'
        )}
      >
        {plan.features.map((feature) => (
          <li key={feature._uid} className="flex dr-gap-8">
            {feature.icon === 'tick' ? (
              <TickSVG className="dr-w-10 flex items-center justify-center" />
            ) : (
              <PlusSVG className="dr-w-10 flex items-center justify-center" />
            )}
            <span className="cta-rg-l text-light-grey">{feature.text}</span>
          </li>
        ))}
      </ul>

      <Link
        href="https://cora.computer/users/sign_up"
        className="bg-black absolute dr-bottom-18 dt:dr-bottom-30 left-1/2 -translate-x-1/2 text-white dr-w-290 dt:dr-w-246 dr-px-65 dr-py-12 dr-rounded-9999 flex dr-gap-10 justify-center group"
      >
        <span className="cta-sb-l inline-block text-nowrap flex-shrink-0 translate-x-[desktop-vw(12)] group-hover:translate-x-[0] transition-transform duration-300">
          Start free trial
        </span>
        <ArrowSVG className="flex dr-w-16 transition-all duration-300 opacity-0 group-hover:opacity-100 shrink-0" />
      </Link>
    </div>
  )
}
